<template>
  <!-- ************* VETRINA DI UN FORNITORE ********** -->
  <!-- Mostra gli articoli che il fornitore può vendere -->
  <div>
      <PageTagline :elements="tagline_elem" />

      <!-- Overlay di caricamento della pagina -->
      <CustomOverlay :show="overlay_show" text="Caricamento in corso, attendere...">

        <b-button pill size="sm" @click="torna_ai_fornitori">
          <b-icon icon="caret-left-fill"></b-icon>Torna alle convenzioni
        </b-button>

        <!-- LOGO O NOME DEL FORNITORE -->
        <!-- v-if info_forn renderizza il logo quando le info del fornitore sono -->
        <!-- state caricate, se non lo usiamo si verifica un errore di rendering -->
        <!-- perchè vue tenta di renderizzare subito informazioni che ancora non -->
        <!-- ha in quanto le infor sul fornitore non sono disponibili da subito  -->
        <b-row class="mt-4" v-if="info_forn">
          <b-col class="text-center">
            <div v-if="info_forn.logo_url">
              <b-img :src="info_forn.logo_url" alt="logo"></b-img>
            </div>
            <div v-else>
              <h3 class="pb-3">{{info_forn.nome}} {{info_forn.cognome}}</h3>
            </div>
          </b-col>
        </b-row>
        <!-- STRINGA DI RICERCA TRA GLI ARTICOLI -->
        <b-row class="border-bottom">
          <b-col></b-col>
          <b-col cols="md-4">
            <b-form-group id="group-item-search"
              label="Cerca tra gli articoli:"
              label-for="item-search">
                <b-form-input
                  id="item-search"
                  v-model="filtro_ricerca"
                  debounce="500"
                ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col></b-col>
        </b-row>
        <!-- CONTENUTO DELLA VETRINA -->
        <div class="mt-5">
          <!-- Overlay di caricamento della vetrina: per caricamento al cambio pagina -->
          <b-overlay :show="overlay_vetrina" spinner-variant="primary">
            <!-- VETRINA -->
            <b-row v-for="(row_elem, index) in parted_vetrina" :key="index" >
              <!-- Mettiamo 6 elementi per riga ( md-2 grandezza colonna 2)    -->
              <!-- sugli schermi piccoli andiamo in stacked, mentre la colonna -->
              <!-- è alta il 100% della riga ( classe h-100 ) -->
              <b-col :cols="item_column_size" class="item-container text-center h-100 mb-3 pb-2" v-for="( articolo, index ) in row_elem" :key="index">
                  <b-link class="item-link" @click="apri_articolo(articolo.id)" :title="articolo.descrizione">
                    <!-- IMMAGINE O ICONA ( no foto ) -->
                    <!-- Prendiamo se presente, la prima immagine dell'articolo -->
                    <div v-if="articolo.imgs[0]">
                      <b-img fluid class="img-preview" :src="articolo.imgs[0].web_url"></b-img>
                    </div>
                    <div v-else class="no-photo-preview">
                      <b-iconstack font-scale="4">
                        <b-icon stacked icon="cart4" scale="0.50"></b-icon>
                        <b-icon stacked icon="circle"></b-icon>
                      </b-iconstack>
                      <p class="no-photo-description">Immagine non disponibile</p>
                    </div>
                    <!-- DESCRIZIONE e PREZZO ( e sconto se presente ) -->
                    <div class="mt-3 description-container">
                      <h6 class="description-text">{{articolo.descrizione}}</h6>
                      <h5 v-if="articolo.prezzo_unitario > 0">
                        {{articolo.prezzo_unitario}} €
                        <b-badge class="ml-2" v-if="articolo.sconto > 0" pill variant="success">Sconto {{articolo.sconto}}%</b-badge>
                      </h5>
                    </div>
                  </b-link>
              </b-col>
            </b-row>
            <!-- PAGINATORE -->
            <b-pagination v-model="current_page"
                          v-if="show_paginatore"
                          :total-rows="total_rows"
                          :per-page="page_size"
                          @input="update_vetrina_da_paginatore"
                          align="center">
            </b-pagination>
          </b-overlay>
        </div>
      </CustomOverlay>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'VetrinaFornitore',
  data () {
    return {
      tagline_elem : [ { text : "Convenzioni special", link : 'home-fornitori' },
                       { text : "Vetrina Fornitore", link : '' } ],

      // Overlay di caricamento della pagina
      overlay_show: false,

      // Overlay di caricamento della vetrina
      overlay_vetrina: false,

      // Informazioni sul fornitore e dati della vetrina
      info_forn: null,

      // Numero di elementi per ogni riga
      item_by_row: 6,

      // Dimensione delle colonne con gli item, siccome
      // vogliamo avere 6 elementi per riga utilizziamo
      // la classe bootstrap md-2 ( 12/2 = 6 )
      item_column_size: "md-2",

      // Paginazione e dati della vetrina:
      // Elementi per ogni pagina della vetrina, siccome
      // vogliamo mostrare 3 righe per pagina richiederemo
      // al backend una pagina di 18 elementi.
      page_size: 18,
      // Pagina corrente ( dato valorizzato dal paginatore di bootstrap )
      current_page: null,
      // Numero totale di elementi ( dato valorizzato dal backend )
      total_rows : null,
      // Dati della vetrina
      dati_vetrina: null,

      // Valore della stringa di ricerca
      filtro_ricerca: null

    }
  },
  computed : {
    /**
     * Trasforma il valore dati_vetrina in un array di array con 6 elementi
     * per sotto array ( di modo tale da avere 6 elementi per riga )
     */
    parted_vetrina : function () {
      return generalLib.sub_array_partition( this.dati_vetrina, this.item_by_row );
    },
    /**
     * Una variabile che indica se il paginatore deve comparire.
     * Dovrà essere visibile quando il numero di elementi totali supera
     * quello degli elementi in una pagina.
     */
    show_paginatore : function () {
      let res = false;
      if ( this.total_rows > this.page_size ) res = true;
      return res;
    }
  },
  methods: {
    /**
     * Torna alla home dei fornitori.
     */
    torna_ai_fornitori : function (){
      this.$router.push( { name : 'home-fornitori' } );
    },
    /**
     * Carica la pagina della vetrina indicata dalla variabile interna
     * current_page gestita come v-model dal paginatore.
     */
    update_vetrina_da_paginatore : function (){
      this.carica_vetrina( this.current_page, null );
    },
    /**
     * Carica la vetrina del fornitore, permette di specificare la pagina da
     * caricare e l'eventuale filtro da applicare.
     * - page_num : numero di pagina da caricare.
     * - filter : se applicato torna i soli elementi la cui stringa filter è contenuta
     *            nella descrizione dell'articolo.
     */
    carica_vetrina : function ( page_num = null, filter = null ){

      // Al paginatore di django specifichiamo sempre la page size voluta
      // ( elementi per pagina da visualizzare, parametro get "page_size" ),
      // ed opzionalmente il numero di pagina da visualizzare ( parametro get "page" ),
      // se non specificato sarà restituita la prima pagina.
      let params = { page_size : this.page_size };
      if ( page_num != null ) params['page'] = page_num;

      // Se passata usiamo la stringa di ricerca
      if ( filter != null ) params['filter'] = filter;

      let vetrina_forn_call_url = apiUrl.fornitoriapi.get_vetrina.replace( '@id_fornitore', this.id_fornitore );

      this.overlay_vetrina = true;

      axios.get( vetrina_forn_call_url, { params: params } )
      .then( ( response ) => {
        // Aggiorniamo le variabili interne
        this.dati_vetrina = response.data.results;
        this.total_rows = response.data.count;
        this.overlay_vetrina = false;
      })
      .catch( ( error ) => {
        this.overlay_vetrina = false;
        let message = "Si è verificato un errore nel caricamento della vetrina del fornitore, " +
                      "si prega di riprovare, se il problema persiste contattare l'assistenza";
        generalLib.backend_error_message_box( this, message );
        console.error( error.response.data );
      });
    },
    /**
     * Metodo che apre la vetrina dell'articolo richiesto
     *
     * - id_articolo: id dell'articolo dal visualizzare
     */
    apri_articolo : function ( id_articolo ) {
      this.$router.push( { name: 'vetrina-articolo', params: { id_articolo: id_articolo } });
    }
  },
  /**
   * Alla creazione del componente carica le info sul fornitore ed
   * i dati della vetrina. Per gestire al meglio l'overlay di caricamento
   * facciamo il caricamento in cascata invece che in parallelo.
   */
  created : function () {

    this.overlay_show = true;
    let info_forn_call_url = apiUrl.fornitoriapi.get_info_fornitore.replace( '@id_fornitore', this.id_fornitore );

    // Carico prima le informazioni sul fornitore
    axios.get( info_forn_call_url )
    .then( ( response ) => {

      this.info_forn = response.data;
      this.overlay_show = false;

      // Procedo ora a caricare la vetrina, non specificando il
      // numero di pagina partirò dalla prima, non specifico
      // nemmeno il filtro.
      this.carica_vetrina();
    })
    .catch( ( error ) => {
      this.overlay_show = false;
      let message = "Si è verificato un errore nel caricamento delle informazioni sul fornitore, " +
                    "si prega di riprovare, se il problema persiste contattare l'assistenza";
      generalLib.backend_error_message_box( this, message );
      console.error( error.response.data );
    });

  },
  watch : {
    /**
     * Quando il valore del filtro di ricerca cambia, invochiamo il caricamento
     * della vetrina con applicato il filtro per poter visualizzare solo gli
     * articoli che contengono la parola chiave.
     * La stringa di ricerca ha un valore di debounce di 500ms, ciò significa che
     * la variabile viene updatata 500ms secondi dopo che l'utente ha finito di digitare.
     */
    filtro_ricerca : function ( val ){
      // se abbiamo cancellato la stringa di ricerca ricarichiamo
      // la vetrina ex-novo.
      if ( val == '' || val === null ) {
        this.carica_vetrina( null, null );
      } else {
        this.carica_vetrina( null, val );
      }
    }
  },
  props : {
    /**
     * Id del fornitore del quale visualizzare i dati, è necessario
     * fornirlo per poterlo visualizzare.
     */
    id_fornitore: {
      type: [ String, Number ],
      required: true
    }
  },
  components : {
    PageTagline,
    CustomOverlay
  }
}
</script>

<style scoped>
/* Immagine di anteprima degli articoli */
.img-preview {
  max-width: 300px;
  max-height: 150px;
}

/* Altezza del div con l'icona della foto
   mancante, deve essere pari alla massima
   altezza dell'immagine di preview */
.no-photo-preview {
  height: 150px;
}

/* Allineamento orizzontale dell'icona
  di foto mancante, ci riferiamo all'oggetto
  svg compilato che si ottiene dalle due
  b-icon che mettiamo insieme */
.no-photo-preview :deep( svg ) {
  vertical-align: -1.30em;
}

/* Rendiamo piccola e in gricetto la scritta
   "Immagine non disponibile" sotto all'icona
   del ccarrello */
.no-photo-description {
  margin-top: 4px;
  font-size: 0.9em;
  font-style: italic;
  color: #8b8c8c;
}

/* La presenza del link non deve apportare modifiche
   al layout del contenuto */
.item-link {
 color: #000000;
}
.item-link:hover {
 text-decoration: none;
}

/* Quando passiamo sopra il testo della descrizione deve
   cambiare colore */
.item-link:hover .description-container {
  /*color:rgba(0,0,0,.125);*/
  color:#a1a1a1;
}

/* Visualizziamo i puntini di sospensione nel testo della
  descrizione dopo la seconda riga. L'altezza dell'elemento
  che contiene la descrizione la fissiamo a 40px che sono
  l'altezza delle due righe in modo tale da allineare poi
  i prezzi e gli sconti tra di loro.  */
.description-text {
  height: 40px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Normalmente il container dei vari items si evidenzia in
   grigetto quando ci si passa sopra */
.item-container:hover {
  background: #f7f7f7;
  border-radius: 10px;
}

/* Negli schermi più piccoli del desktop deve invece comparire
   il bordo inferiore per separare tra loro gli articoli senza
   evidenziazione */
@media (max-width: 768px) {
  .item-container {
    border-bottom: 1px solid rgba(0,0,0,.125);
  }
}
</style>